/**
 * Central object used for Store StudentTasks module
 */

interface StudentTasksFilters {
  academic_year_id: number | null
  year_group_id: number | null
  sub_group_id: number | null
  status: string | null
  task_id: number | null
  assigned_by_user_id: number | null
  search: string | null
  page: number
  per_page: number
}

interface StudentTasksState {
  filters: StudentTasksFilters
}

export const useStudentTasksStore = defineStore('studentTasks', {
  state: (): StudentTasksState => ({
    filters: {
      academic_year_id: null,
      year_group_id: null,
      sub_group_id: null,
      status: null,
      task_id: null,
      assigned_by_user_id: null,
      search: null,
      page: 1,
      per_page: 50,
    },
  }),
  actions: {
    setAcademicYearFilter(academicYearId: number) {
      this.filters.academic_year_id = academicYearId
    },
  },
})
